import TextField from '@/components/TextField/TextField';
import styled from '@emotion/styled';
import { useFormContext } from 'react-hook-form';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;

export const DescriptionField = () => {
    const { register } = useFormContext();

    return (
        <Container>
            <Title id="campaign-description-field">Description</Title>
            <TextField
                multiline
                placeholder="Enter your description here"
                rows={3}
                inputProps={{ ...register('description'), 'data-hj-allow': '' }}
            />
        </Container>
    );
};
